
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator/dealer/[slug]",
      function () {
        return require("private-next-pages/store-locator/dealer/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-locator/dealer/[slug]"])
      });
    }
  